import React from 'react'
import {Content} from '@builder.io/sdk-react'
import {customComponents, builderConfig} from 'hec/builder'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import PropTypes from 'prop-types'

export const PageContent = ({data}) => {
    const config = getConfig()
    return (
        <div className="min-h-screen">
            <Content
                model={builderConfig.pageModel}
                content={data}
                apiKey={config.app.builder.api}
                customComponents={customComponents}
            />
        </div>
    )
}

PageContent.propTypes = {
    data: PropTypes.object
}
